<template lang="pug">
NuxtLayout
    Html(translate='no')
    UApp
        ClientOnly
            UButton.rounded-none(
                v-if="needRefresh"
                @click="updateServiceWorker()"
                variant="solid"
                color="primary"
                label="Update Available"
                block
                size="sm"
            )
        NuxtLoadingIndicator
        NuxtPage
</template>
<script setup lang="ts">
import { onMessage } from "firebase/messaging";
import { onMounted, ref } from "vue";
//provideHeadlessUseId(() => useId());
// useHead({
//     script: [
//         { src: '/newrelic.js', defer: true }
//     ]
// });

const needRefresh = ref(false);
const updateServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      try {
        window.location.reload();
      } catch (e) {
        location.reload();
      }
    }
  } else {
    try {
      window.location.reload();
    } catch (e) {
      location.reload();
    }
  }
};
if (process.env.NODE_ENV === "production") {
  onMounted(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        window.location.reload();
        needRefresh.value = true;
      });
    }
  });
}

const { $fcm } = useNuxtApp();
const toast = useToast();

let deferredPrompt;

onMounted(() => {
  if (window) {
    window.addEventListener("beforeinstallprompt", (event) => {
      event.preventDefault();
      deferredPrompt = event;
      document.getElementById("installButton").style.display = "block";
    });
    $fcm.requestPermission();
    onMessage($fcm.messaging, (payload) => {
      $fcm.store.messages.unshift(payload);
      toast.add({
        title: payload.notification?.title,
        description: payload.notification?.body,
      });
    });
  }
});
</script>
